import baseAPI from '@/http'

const router = '/api/municipioibge'

export const cadastroEmLoteAPI = {
  cadastrarMunicipios: () => baseAPI.post(`${router + '/popular-municipios-sem-codigo-ibge'}`)
}
